module.exports = __webpack_public_path__ + "static/media/profileAvatar.a794ef9c.svg";